import axios from 'axios';
import common from 'common/js/encipher';

const createObj = {
  timeout: 30000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  }
}

const req = axios.create (
  Object.assign({}, {
    baseURL: process.env.VUE_APP_URL,
    withCredentials: true    // 表示跨域请求时是否需要使用凭证
  }, createObj)
)
const reqNoCred = axios.create (
  Object.assign({}, {
    baseURL: process.env.VUE_APP_URL
  }, createObj)
)
let methodArr = [req, reqNoCred]

// eslint-disable-next-line no-unused-vars
methodArr.map((v, i)=> {
  // 添加请求拦截器
  v.interceptors.request.use (
    function (config) {
      // 在发送请求之前做些什么
      if (sessionStorage.getItem ('token')) {
        config.headers.common['Authorization'] = sessionStorage.getItem ('token');
      }
      if (config.method === 'get') {
        let time = +new Date ();
        var params = Object.assign ({}, config.params, {
          time,
        });
        config.params = {
          sign: common.toSign (params),
          ...params,
        };
      }

      if (
        config.method === 'post' &&
        config.headers['Content-Type'].match (/json/i)
      ) {
        let time = +new Date ();
        let sign = common.signPostJSON (JSON.stringify (config.data), time);
        config.url +=
          (config.url.match (/.*\?\w+/) ? '&' : '?') +
          `time=${time}&sign=${sign}`;
      }

      return config;
    },
    function (error) {
      return Promise.reject (error);
    }
  );

  // 添加响应拦截器
  v.interceptors.response.use (
    function (response) {
      return response.data;
    },
    function (error) {
      return Promise.reject (error);
    }
  );
})

//methods
function methods(withCredentials) {
  if(!withCredentials) {
    return reqNoCred
  }
  return req
}

/**
 * 
 * @param {*} url 链接
 * @param {*} param 请求参数
 * @param {*} headers 请求头
 * @param {*} withCredentials 是否带跨域凭证，默认 true，不需要请传 false
 */
//get
export function get (url, param, headers = {}, withCredentials = true) {
  let method = methods(withCredentials)
  return new Promise ((resolve, reject) => {
    method ({
      method: 'get',
      url,
      headers,
      params: param
    }).then (res => {
      resolve (res);
    }).catch (er => {
      reject (er)
    })
  })
}

// post请求
export function post (url, param, header = {}, withCredentials = true) {
  let method = methods(withCredentials)
  return new Promise ((resolve, reject) => {
    method ({
      method: 'post',
      url,
      header,
      data: param
    }).then (res => {
      resolve (res)
    }).catch (er => {
      reject (er)
    })
  })
}

// centerPost请求
export function centerPost (url, param, header = {}, withCredentials = true) {
  let method = methods(withCredentials)
  const {token, subuserid} = param;
  url = `${url}?token=${token}&subuserid=${subuserid}`;
  return new Promise ((resolve, reject) => {
    method ({
      method: 'post',
      url,
      header,
      data: param
    }).then (res => {
      resolve (res)
    }).catch (er => {
      reject (er)
    })
  })
}